var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMotoGris(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 67,
    viewBox: "0 0 65 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9216",
    "data-name": "Group 9216",
    transform: "translate(483 -226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13486",
    "data-name": "Rectangle 13486",
    width: 65,
    height: 67,
    rx: 32.5,
    transform: "translate(-483 226)",
    fill: "#e1eaec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_005-motocicleta",
    "data-name": "005-motocicleta",
    transform: "translate(-469.612 246.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M31.249,15.017a5.3,5.3,0,0,0-2.429.609L27.37,13.9a7.155,7.155,0,0,1,2.073-.837,8.733,8.733,0,0,1,1.812-.194,3.062,3.062,0,0,0,2.175-.892A3.368,3.368,0,0,0,34.4,9.528,9.607,9.607,0,0,0,24.881,0H23.669a1.073,1.073,0,0,0,0,2.145h1.212a7.243,7.243,0,0,1,.933.095V4.313a5.319,5.319,0,0,0-1.765.508c-.007-.008-.016-.013-.023-.022a5.349,5.349,0,0,0-2.189,1.88L19.4,10.341a1.075,1.075,0,0,1-.73.465,6.762,6.762,0,0,0-5.042,3.74,8.532,8.532,0,0,1,1.464,4.762H12.871a6.53,6.53,0,1,0-.4,2.145H22.6a1.072,1.072,0,0,0,1.073-1.073,8.047,8.047,0,0,1,.211-1.808A7.32,7.32,0,0,1,25.7,15.248l1.448,1.72a5.311,5.311,0,0,0-1.259,3.411,5.363,5.363,0,1,0,5.363-5.363ZM6.436,23.6a4.29,4.29,0,1,1,4.29-4.29H7.508a1.073,1.073,0,0,1-1.073-1.073,1.073,1.073,0,0,0-2.145,0,3.222,3.222,0,0,0,3.218,3.218H10.13A4.276,4.276,0,0,1,6.436,23.6Zm24.813,0a3.222,3.222,0,0,1-3.218-3.218,3.188,3.188,0,0,1,.492-1.69l1.888,2.36a1.073,1.073,0,1,0,1.676-1.341L30.2,17.352a3.176,3.176,0,0,1,1.048-.19,3.218,3.218,0,1,1,0,6.436Zm0,0",
    transform: "translate(0 0)",
    fill: "#0b71c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M174.713,36.1l1.838-2.757a7.474,7.474,0,0,1,2.233-2.154A7.436,7.436,0,0,0,174.8,30a7.529,7.529,0,0,0-6.253,3.364l1.716,1.03A14.314,14.314,0,0,0,174.713,36.1Zm0,0",
    transform: "translate(-156.498 -27.855)",
    fill: "#0b71c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M12.664,64.087,5.781,60H1.072A1.072,1.072,0,0,0,0,61.072a5.37,5.37,0,0,0,5.363,5.363c2.146,0,4.371.047,6.756,2.12.009-.017.009-.036.02-.053a8.889,8.889,0,0,1,3.354-3.1,16.443,16.443,0,0,1-2.828-1.311Zm0,0",
    transform: "translate(0.001 -55.709)",
    fill: "#0b71c3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotoGris);
export default __webpack_public_path__ + "static/media/MotoGris.14b7fa31989af2bc7397217fc8f76450.svg";
export { ForwardRef as ReactComponent };